import { MESSAGE_ACTIONS } from "stream-chat-react";

/**
 * The SDK actions a message offers. "flag" is Stream's own moderation report, which nobody on our
 * side reviews — the DSA "Report" custom action (ZS-1743) is the one that reaches staff, so the
 * built-in is hidden everywhere a message list is rendered.
 */
export const MESSAGE_ACTIONS_WITH_THREADS = Object.values(
  MESSAGE_ACTIONS,
).filter((action) => action !== MESSAGE_ACTIONS.flag);

// Additionally without "reply" (start a thread) while manual threading is off; "quote" is a
// quoted reply inside the conversation and stays.
export const MESSAGE_ACTIONS_WITHOUT_THREADS =
  MESSAGE_ACTIONS_WITH_THREADS.filter(
    (action) => action !== MESSAGE_ACTIONS.reply,
  );
